///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ChangeDetectionStrategy, Component, computed, EventEmitter, Input, Output, Signal, signal, WritableSignal } from '@angular/core';
import { ProjectDragAndDropService } from '../project-drag-and-drop.service';
import { FolderTreeNode } from '../folders-tree/folders-tree.service';
import { UserAuthorities } from '../../services/user/user-authorities';
import { ProjectsViewStateService } from '../projects-view-state.service';

@Component({
    selector: 'winde-folders-list',
    templateUrl: './folders-list.component.html',
    styleUrls: ['./folders-list.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GtthFoldersListComponent {
    public drugOverFolderId: number;
    public searchFilter: Signal<string>;
    public foldersToShow: Signal<FolderTreeNode[]>;
    public foldersList: WritableSignal<FolderTreeNode[]>;
    @Output() openChild: EventEmitter<number> = new EventEmitter<number>();
    protected readonly userAuthorities = UserAuthorities;

    constructor(
        public readonly projectDragAndDropService: ProjectDragAndDropService,
        private readonly projectsViewStateService: ProjectsViewStateService
    ) {
        this.searchFilter = this.projectsViewStateService.searchFilter;
        this.foldersList = signal([]);
        this.foldersToShow = computed(() =>
            this.foldersList().filter((folder) => folder.name.toLowerCase().search(this.searchFilter().toLowerCase()) !== -1)
        );
    }

    @Input() set folders(value: FolderTreeNode[]) {
        this.foldersList.set(value);
    }

    public openChildFolder(folderId: number) {
        this.openChild.emit(folderId);
    }

    public dragOver(folderId?: number) {
        this.drugOverFolderId = folderId;
        this.projectDragAndDropService.setOpenFolderTimer(this.drugOverFolderId, () => {
            this.openChildFolder(this.drugOverFolderId);
        });
    }
}
